import { CREATE_QIZZES, GET_QIZZES, SET_ALL_QUIZZES, UPDATE_QIZZES } from "../../reducerTypes"

const initialState = {
  getData: {},
  getEditData: {},
  getList: [],
}

const quizReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_QUIZZES:
      return{
        ...state,
        getList: action.payload
      }
    case CREATE_QIZZES:
      return{
        ...state,
        getData: action.payload
      }
    case GET_QIZZES:
    return{
      ...state,
      getEditData: action.payload
    }
    case UPDATE_QIZZES: 
    return{
      ...state,
      getData: action.payload
    }
    default:
      return state
  }
}

export default quizReducer
